import React from 'react';
import { useNavigate } from 'react-router-dom';

const FeedBackFormSubmit = ({ translationMap }) => {
  const navigate = useNavigate();
  return (
    <div>
            <div className="modal fade Custom_Modal_Box show" id="baraemFeedback" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block" }}>
                <div className="modal-dialog  CoveragePlan_Dialog3" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="Title_Inner_Box">
                                <h6 className="MainTitleOne">
                                    {translationMap?.feedback ?? "Feedback"}
                                </h6>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="baraem_modal_body">
                                <div className="AlertInnerBox GreenAlertInnerBox alert">
                                    <div className="Icon_box">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                        <a href="javascript:void(0);">
                                            <span className="material-symbols-outlined">
                                                check_circle
                                            </span>
                                        </a>
                                    </div>
                                    <div className="alert_text">
                                        <h6>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                            <a href="javascript:void(0);">
                                                {translationMap?.feebackSubmittedSuccess ?? " Feedback has been submitted successfully."}
                                            </a>
                                        </h6>
                                    </div>
                                </div>
                                <div className="congrates_inner_box">
                                    <h6 className="Gray_Title">
                                        {translationMap?.thankYouForSharingFeedback ?? "Thank you for sharing your feedback."}
                                    </h6>
                                    <p className="para_txt1">
                                        {translationMap?.thisWillHelpEnhanceServices ?? "This will help us to enhance our services."}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer modal_footer_btn_box3">
                            <button type="button" className="btn bluetrans_btn_link" data-dismiss="modal" onClick={() => navigate("/")}> {translationMap?.returnToBaraemScreen ?? "Return to Bara’em main screen"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>);

};

export default FeedBackFormSubmit;